import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"
import { isValidUUID } from "@csrc/utility/Utils"
import { IScoring } from "./asset"
import { SimpleRuleItem } from "../simple-rule"
import _ from 'lodash'

export class ListOptionsVM extends CommonOptionVM {
  default_value?: string | string[]
  options_type?: string
  response_set_id?: string

  required?: boolean
  multiple_selection?: boolean
  read_only?: boolean
  require_media?: boolean
  require_note?: boolean
  simple_rule?: SimpleRuleItem[]

  enable_score?: boolean;
  scoring?: IScoring;

  constructor(data: Partial<ListOptionsVM> = {}) {
    super(data)
    this.options_type = data?.options_type ?? undefined
    this.response_set_id = data?.response_set_id || undefined

    this.required = data?.required ?? undefined
    this.multiple_selection = data?.multiple_selection ?? undefined
    this.read_only = data?.read_only ?? undefined
    this.require_media = data?.require_media ?? undefined
    this.require_note = data?.require_note ?? undefined
    this.simple_rule = data.simple_rule ? _.map(data.simple_rule, x => new SimpleRuleItem(x as any)) : undefined

    if (this.multiple_selection) {
      this.default_value = Array.isArray(data?.default_value) ? data?.default_value : (data?.default_value ? [data?.default_value] : undefined)
    } else {
      this.default_value = Array.isArray(data?.default_value) ? (data?.default_value.length > 0 ? data?.default_value[0] : undefined) : (data?.default_value ?? undefined)
    }

    this.enable_score = data.enable_score ?? undefined
    this.scoring = this.enable_score ? {
      min_point: this.scoring?.min_point ?? 0,
      max_point: this.scoring?.max_point ?? null,
      scoring_weight: this.scoring?.scoring_weight ?? 1
    } : undefined
  }

  validateData() {
    const errors: any[] = []
    if (!isValidUUID(this.response_set_id ?? '')) {
      errors.push({ key: 'response_set_id', error_message: 'Response set id is invalid must be uuid' })
    }

    if (this.multiple_selection) {
      if (this.default_value !== null && this.default_value !== undefined) {
        if (!Array.isArray(this.default_value)) {
          errors.push({ key: 'default_value', error_message: 'Default value must be an array when multiple selection is enabled' })
        } else if (this.default_value.some(val => typeof val !== 'string')) {
          errors.push({ key: 'default_value', error_message: 'Default value must be an array of strings when multiple selection is enabled' })
        }
      }
    } else {
      if (this.default_value !== null && this.default_value !== undefined) {
        if (Array.isArray(this.default_value) || typeof this.default_value !== 'string') {
          errors.push({ key: 'default_value', error_message: 'Default value must be a string when multiple selection is disabled' })
        }
      }
    }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default ListOptionsVM